import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FooterSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    if (location.pathname === "/") {
      // Если уже на главной странице, просто прокручиваем к футеру
      const footerElement = document.getElementById("footer");
      if (footerElement) {
        footerElement.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Если на другой странице, переходим на главную и прокручиваем к футеру
      navigate("/");
      // Используем более надежный способ ожидания загрузки элемента
      const scrollToFooter = () => {
        const footerElement = document.getElementById("footer");
        if (footerElement) {
          footerElement.scrollIntoView({ behavior: "smooth" });
        } else {
          // Если элемент еще не загружен, пробуем еще раз
          setTimeout(scrollToFooter, 50);
        }
      };
      setTimeout(scrollToFooter, 100);
    }
  };
  return (
    <footer id="footer" className="w-full bg-[#881f1f] text-white">
      <div className="max-w-full mx-auto px-[30px] md:px-[60px] py-10 md:py-[70px]">
        {/* Логотип */}
        <div className="mb-6 md:mb-[50px]">
          <div className="h-[36px] md:h-[50px] w-auto">
            <img
              src="/Logo Bina.svg"
              alt="Bina Qurylys logo"
              className="h-full w-auto"
            />
          </div>
        </div>

        {/* Жоғарғы сызық (барлық брейкпоинттерде) */}
        <div className="h-px w-full bg-white/80" />

        {/* Контент — макеттерді біріктірілген responsive сетка */}
        <div className="mt-6 md:mt-10 text-[12px] leading-[22px]">
          {/* Мобильді версия: вертикаль блоктар, әр блоктың астында сызық */}
          <div className="flex flex-col md:hidden space-y-0">
            {/* Контактілер блок */}
            <div className="space-y-4 pt-6">
              <div>
                <p className="font-['Montserrat'] font-light">
                  {t("footer.sales")}
                </p>
                <p className="font-['Montserrat'] font-medium text-[14px]">
                  +7 771 005 10 60
                </p>
              </div>
              <div>
                <p className="font-['Montserrat'] font-light">{t("footer.reception")}</p>
                <p className="font-['Montserrat'] font-medium text-[14px]">
                  +7 777 750 30 55
                </p>
              </div>
              <div>
                <p className="font-['Montserrat'] font-light">
                  {t("footer.director")}
                </p>
                <p className="font-['Montserrat'] font-medium text-[14px]">
                  +7 778 142 94 98
                </p>
              </div>
              <p className="font-['Montserrat'] font-medium text-[14px]">
                info@binaqurylys.kz
              </p>
            </div>
            {/* Email-дің астында сызық */}
            <div className="h-px w-full bg-white/80 mt-6" />

            {/* Адрес блок */}
            <div className="space-y-4 pt-6">
              <div>
                <p className="font-['Montserrat'] font-light text-[12px]">{t("footer.addressLabel")}</p>
                <p className="font-['Montserrat'] font-medium text-[12px]">
                  {t("footer.addressValue")}
                </p>
              </div>
            </div>
            {/* Address-тің астында сызық */}
            <div className="h-px w-full bg-white/80 mt-6" />

            {/* Соцсети блок */}
            <div className="space-y-1 pt-6">
              <p className="font-['Montserrat'] font-light text-[12px]">{t("footer.socialWhatsApp")}</p>
              <p className="font-['Montserrat'] font-light text-[12px]">{t("footer.socialTelegram")}</p>
              <p className="font-['Montserrat'] font-light text-[12px]">{t("footer.socialInstagram")}</p>
            </div>
            {/* Instagram-ның астында сызық */}
            <div className="h-px w-full bg-white/80 mt-6" />

            {/* Навигация блок */}
            <div className="flex flex-col space-y-1 pt-6">
              <Link to="/" className="font-['Montserrat'] font-light text-[12px]">
                {t("nav.home")}
              </Link>
              <Link to="/about" className="font-['Montserrat'] font-light text-[12px]">
                {t("nav.about")}
              </Link>
              <Link to="/services" className="font-['Montserrat'] font-light text-[12px]">
                {t("nav.services")}
              </Link>
              <Link to="/projects" className="font-['Montserrat'] font-light text-[12px]">
                {t("nav.projects")}
              </Link>
              <a
                href="#contacts"
                onClick={handleContactsClick}
                className="font-['Montserrat'] font-light text-[12px] cursor-pointer"
              >
                {t("nav.contacts")}
              </a>
            </div>
            {/* Навигацияның астында сызық */}
            <div className="h-px w-full bg-white/80 mt-6" />
          </div>

          {/* Desktop/Tablet версия: grid layout */}
          <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Контактілер сол жақта */}
            <div className="space-y-4">
              <div>
                <p className="font-['Montserrat'] font-light text-[12px]">
                  {t("footer.sales")}
                </p>
                <p className="font-['Montserrat'] font-medium text-[12px]">
                  +7 771 005 10 60
                </p>
              </div>
              <div>
                <p className="font-['Montserrat'] font-light text-[12px]">{t("footer.reception")}</p>
                <p className="font-['Montserrat'] font-medium text-[12px]">
                  +7 777 750 30 55
                </p>
              </div>
              <div>
                <p className="font-['Montserrat'] font-light text-[12px]">
                  {t("footer.director")}
                </p>
                <p className="font-['Montserrat'] font-medium text-[12px]">
                  +7 778 142 94 98
                </p>
              </div>
              <p className="font-['Montserrat'] font-medium text-[12px]">
                info@binaqurylys.kz
              </p>
            </div>

            {/* Адрес + социалки */}
            <div className="space-y-4">
              <div>
                <p className="font-['Montserrat'] font-light text-[12px]">{t("footer.addressLabel")}</p>
                <p className="font-['Montserrat'] font-medium text-[12px]">
                  {t("footer.addressValue")}
                </p>
              </div>
              <div className="space-y-1">
                <p className="font-['Montserrat'] font-light text-[12px]">{t("footer.socialWhatsApp")}</p>
                <p className="font-['Montserrat'] font-light text-[12px]">{t("footer.socialTelegram")}</p>
                <p className="font-['Montserrat'] font-light text-[12px]">{t("footer.socialInstagram")}</p>
              </div>
            </div>

            {/* Навигация */}
            <div className="flex flex-col space-y-1 md:col-span-2 lg:col-span-1 md:mt-4 lg:mt-0">
              <Link to="/" className="font-['Montserrat'] font-light text-[12px]">
                {t("nav.home")}
              </Link>
              <Link to="/about" className="font-['Montserrat'] font-light text-[12px]">
                {t("nav.about")}
              </Link>
              <Link to="/services" className="font-['Montserrat'] font-light text-[12px]">
                {t("nav.services")}
              </Link>
              <Link to="/projects" className="font-['Montserrat'] font-light text-[12px]">
                {t("nav.projects")}
              </Link>
              <a
                href="#contacts"
                onClick={handleContactsClick}
                className="font-['Montserrat'] font-light text-[12px] cursor-pointer"
              >
                {t("nav.contacts")}
              </a>
            </div>
          </div>

          {/* Төменгі сызық (desktop/tablet үшін) */}
          <div className="hidden md:block h-px w-full bg-white/80 mt-8" />

          {/* Төменгі жолдар */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-1 text-[10px] font-['Montserrat'] font-light leading-[22px] text-[#c6c6c6]">
            <p>{t("footer.rights")}</p>
            <p>{t("footer.privacy")}</p>
            <p className="md:text-right">{t("footer.dev")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
